class TxnSerializer {
  static toDBFormat(transactions) {
    return transactions.steps?.map((step) => {
      return step.toJSON();
    });
  }

  static toRemirrorFormat(transactions) {
    return transactions.steps?.map((step) => {
      const { type, attrs } = step;
      return {
        stepType: type,
        from: attrs.from,
        to: attrs.to,
        ...(attrs.structure && { structure: attrs.structure }),
        slice: {
          openStart: attrs.data[0]?.openStart,
          openEnd: attrs.data[0]?.openEnd,
          content: attrs.data[0].content || [],
        },
      };
    });
  }
}

export { TxnSerializer };
